import apiServices, { connectorClient } from '../utils/axios';

export const fetchLoadPushData = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`/loads/push`, payload);
  return res.data;
};

export const fetchLoadPushDataFormSGBuildex = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`/loads/push/forms`, payload);
  return res.data;
};

export const fetchLoadPushDataCCTLab = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`loads/push/cct`, payload);
  return res.data;
};

export const fetchLoadPushDataCCTContractor = async (connectionId, payload) => {
  const res = await connectorClient(connectionId).post(`sgbuildex/push/concrete_cube_test_contractor`, payload);
  return res.data;
};

export const fetchParticipantList = async (connectionId, element) => {
  const res = await connectorClient(connectionId).get(`sgbuildex/participants/${element}`);
  return res.data;
};
